import {Injectable} from '@angular/core';
import {DexSecuritiesSubjectService} from '../subjects/dex-securities-subject-service';
import {ComputedTradable} from '../types/computed/computed-tradable';
import {Tradable, TradableId} from '../types/tradable';

@Injectable()
export class DexComputedTradableService {

    constructor(
        private readonly dexSecuritiesSubjectService: DexSecuritiesSubjectService
    ) {}

    public create(tradable: Tradable): ComputedTradable {
        return {
            raw:                 tradable,
            priceDeliverable:    this.dexSecuritiesSubjectService.getDeliverableById(tradable.priceDeliverableId),
            quantityDeliverable: this.dexSecuritiesSubjectService.getDeliverableById(tradable.quantityDeliverableId)
        };
    }

    public createById(tradableId: TradableId): ComputedTradable {
        return this.create(this.dexSecuritiesSubjectService.getTradableById(tradableId));
    }

}
